import { useState, useMemo } from "react";
import styles from "./Mensagens.module.scss";

// ─── Banco de mensagens ───────────────────────────────────────────────────────

const MSGS = [
  {
    cat: "Boas-vindas",
    icon: "👋",
    items: [
      {
        label: "Boas-vindas completo",
        badge: null,
        text: `Olá! 👋 Seja muito bem-vindo(a) ao *FluxoEasy*!

Fico feliz em ter você com a gente. Vou te passar aqui os dados de acesso e um resumo do que você já pode usar hoje:

🔐 *Seus dados de acesso:*
🌐 Link: https://cliente.fluxoeasy.com.br
👤 Login: {LOGIN}
🔑 Senha: {SENHA}

Com o FluxoEasy você consegue:
✅ Criar orçamentos rápidos e profissionais
✅ Controlar seu estoque
✅ Registrar vendas e aluguéis
✅ Agendar serviços
✅ Gerenciar múltiplos usuários
✅ Emitir relatórios

Qualquer dúvida é só chamar! Estamos aqui pra te ajudar em cada passo. 💙`,
      },
      {
        label: "Boas-vindas simples",
        badge: null,
        text: `Oi! Tudo bem? 😊

Seja bem-vindo(a) ao *FluxoEasy*!

Seu acesso já está ativo. Vou te mandar os dados por aqui mesmo:

🌐 https://cliente.fluxoeasy.com.br
👤 Login: {LOGIN}
🔑 Senha: {SENHA}

Qualquer dúvida me chama! 💙`,
      },
    ],
  },
  {
    cat: "Promoção",
    icon: "🏷️",
    items: [
      {
        label: "Promoção de lançamento",
        badge: "promo",
        text: `Oi! 👋 Tenho uma novidade pra te contar!

Estamos com uma *promoção especial* no *FluxoEasy* — nosso sistema completo de gestão para o seu negócio.

🔥 *De R$ 49,90 por apenas R$ 29,90/mês!*

Com ele você tem acesso a:
✅ Orçamentos profissionais
✅ Controle de estoque
✅ Vendas e aluguéis
✅ Agendamentos
✅ Múltiplos usuários
✅ E muito mais!

⏰ Essa condição é por tempo limitado. Aproveita agora! Me chama pra gente bater papo sobre o sistema. 😊`,
      },
      {
        label: "Promoção — cliente que ainda não fechou",
        badge: "promo",
        text: `Oi! Tudo bem? 😊

Passando pra lembrar que nossa *promoção exclusiva* do FluxoEasy ainda tá valendo:

💰 *R$ 29,90/mês* (normalmente R$ 49,90)

Se tiver com alguma dúvida sobre o sistema ou quiser testar antes, posso te liberar um *período de teste gratuito*!

Me fala o que acha, tô por aqui. 👍`,
      },
      {
        label: "Promoção — indicação",
        badge: "promo",
        text: `Oi! 👋

Vi que você conhece bem o FluxoEasy — obrigado pela confiança! 🙏

Tenho uma *condição especial* pra quem indica a gente:
🎁 Seu indicado entra com *R$ 29,90/mês* (de R$ 49,90) e você garante um *desconto na próxima renovação*!

Tem alguém que acha que pode se interessar? Manda o contato que eu cuido do resto! 😊`,
      },
    ],
  },
  {
    cat: "Suporte & engajamento",
    icon: "🎧",
    items: [
      {
        label: "Verificar se o cliente está usando",
        badge: null,
        text: `Oi! Tudo bem? 😊

Passei pra te dar um oi e saber como está sendo sua experiência com o *FluxoEasy*!

Está conseguindo usar o sistema? Tem alguma dúvida que posso te ajudar?

Estou à disposição! 💙`,
      },
      {
        label: "Sumiu faz tempo",
        badge: null,
        text: `Oi! Tudo bem? 😊

Faz um tempinho que não tenho notícias suas! Queria saber como você tá e se o *FluxoEasy* está te ajudando.

Se estiver com alguma dificuldade ou quiser que eu te explique alguma função, é só chamar — estou por aqui! 👍`,
      },
      {
        label: "Está conseguindo usar?",
        badge: null,
        text: `Oi! 👋

Queria te perguntar rapidinho: está conseguindo usar o sistema sem dificuldade?

Qualquer dúvida — por menor que seja — pode me chamar. Às vezes uma coisa simples faz toda a diferença na rotina! 😊`,
      },
      {
        label: "Pós-cadastro — primeiro acesso",
        badge: null,
        text: `Oi! Conseguiu acessar o sistema? 😊

Se precisar de ajuda com o primeiro acesso ou quiser que eu te explique por onde começar, me fala que eu te ajudo!

É bem simples, mas no começo sempre bate uma dúvida. 😄`,
      },
    ],
  },
  {
    cat: "Funcionalidades",
    icon: "📱",
    items: [
      {
        label: "Todas as funcionalidades",
        badge: null,
        text: `Oi! Vou te dar um resumo do que você pode fazer hoje no *FluxoEasy*:

📋 *Orçamentos*
Crie orçamentos rápidos e profissionais com logo da sua empresa, lista de produtos e valores totais. O cliente pode receber em PDF.

📦 *Estoque*
Cadastre seus produtos e acompanhe a quantidade em tempo real. O sistema avisa quando estiver acabando.

💰 *Vendas*
Registre suas vendas e acompanhe o que entrou no caixa, por período.

🔄 *Aluguel*
Controle seus itens de aluguel, datas de saída e devolução, tudo organizado num painel.

📅 *Agendamentos*
Marque serviços e compromissos direto no sistema, com calendário integrado.

👥 *Múltiplos usuários*
Adicione colaboradores com níveis de acesso diferentes — cada um vê só o que precisa.

Quer que eu te explique alguma parte com mais detalhes? 😊`,
      },
      {
        label: "Explicar orçamentos",
        badge: null,
        text: `Oi! Vou te explicar como funciona o módulo de *orçamentos* no FluxoEasy 📋

É bem simples:

1️⃣ Você vai em "Orçamentos" e clica em novo orçamento
2️⃣ Coloca o nome do cliente e os produtos ou serviços
3️⃣ O sistema já calcula o total automaticamente
4️⃣ Você gera um PDF profissional com a logo da sua empresa

O cliente recebe um orçamento bonito e organizado — passa muito mais credibilidade! 💪

Qualquer dúvida me chama! 😊`,
      },
      {
        label: "Explicar controle de estoque",
        badge: null,
        text: `Vou te explicar o *controle de estoque* do FluxoEasy 📦

Funciona assim:

1️⃣ Você cadastra seus produtos com nome, quantidade e preço
2️⃣ A cada venda, o estoque abate automaticamente
3️⃣ Você vê em tempo real o que tem e o que tá acabando
4️⃣ Dá pra cadastrar alertas de estoque mínimo

Nada mais de surpresa na hora que o cliente pede e você não tem! 😄

Tô por aqui se tiver dúvida! 💙`,
      },
      {
        label: "Explicar agendamentos",
        badge: null,
        text: `Oi! Sobre o módulo de *agendamentos* do FluxoEasy 📅

É seu calendário dentro do sistema:

✅ Você marca serviços, visitas ou compromissos
✅ Vê tudo organizado por dia/semana/mês
✅ Evita conflito de horários
✅ Toda sua equipe vê os agendamentos em tempo real

Perfeito pra quem trabalha com serviços, locações ou tem equipe em campo. 💪

Me chama se quiser que eu mostre como usar! 😊`,
      },
      {
        label: "Explicar painel de aluguel",
        badge: null,
        text: `Oi! Deixa eu te explicar o painel de *aluguel* do FluxoEasy 🔄

Se você trabalha com locação de qualquer coisa — equipamentos, trajes, itens de festa — o sistema te ajuda a:

📌 Saber o que saiu e quando volta
📌 Ver o que está disponível agora
📌 Registrar o cliente que alugou
📌 Acompanhar o prazo de devolução

Acabou a confusão de caderninho ou planilha! 😄

Tem dúvida? Me chama! 💙`,
      },
      {
        label: "Explicar múltiplos usuários",
        badge: null,
        text: `Oi! Sabia que você pode ter *vários usuários* no FluxoEasy? 👥

Funciona assim:

👤 Você é o *admin* — vê tudo
👤 Seus funcionários entram com login próprio deles
👤 Cada um só acessa o que você liberar

Assim um vendedor registra a venda, outro cuida do estoque, e você acompanha tudo de cima! 🙌

Me chama se quiser adicionar usuários agora! 😊`,
      },
    ],
  },
  {
    cat: "Cobrança & renovação",
    icon: "💰",
    items: [
      {
        label: "Vencimento se aproximando",
        badge: null,
        text: `Oi! Tudo bem? 👋

Passando para avisar que o vencimento da sua assinatura do *FluxoEasy* está chegando.

📅 Vencimento: *{DATA_VENCIMENTO}*

Para não perder o acesso, é só me chamar que a gente renova rapidinho! 😊

*FluxoEasy* 💙`,
      },
      {
        label: "Véspera de vencimento",
        badge: null,
        text: `Oi! 🚨

Lembrete importante: sua assinatura do *FluxoEasy* vence *amanhã*!

Para garantir que não vai perder o acesso, me chama agora e a gente resolve em minutos. 😊

*FluxoEasy* 💙`,
      },
      {
        label: "Acesso suspenso — cobrança",
        badge: null,
        text: `Oi! 👋

Identifiquei que sua assinatura do *FluxoEasy* está em aberto e o acesso pode ser suspenso em breve.

📅 Vencimento: *{DATA_VENCIMENTO}*

Para regularizar é só me chamar — a gente resolve rapidinho e você volta a usar o sistema sem interrupção! 😊

*FluxoEasy* 💙`,
      },
      {
        label: "Proposta de renovação anual",
        badge: null,
        text: `Oi! 😊

Queria te fazer uma proposta especial: que tal renovar o *FluxoEasy* por 12 meses e economizar?

Pagando o anual você garante um valor fixo, sem reajuste, e não precisa se preocupar com renovação todo mês.

Me chama que te passo os detalhes! 💙`,
      },
    ],
  },
  {
    cat: "Pesquisa & feedback",
    icon: "⭐",
    items: [
      {
        label: "Pesquisa de satisfação",
        badge: null,
        text: `Oi! 😊

Posso te pedir um favorzinho rápido?

Queria saber o que você está achando do *FluxoEasy*. Sua opinião é muito importante pra gente continuar melhorando!

👇 Me dá uma nota de 1 a 5:
⭐ 1 — Muito ruim
⭐⭐ 2 — Ruim
⭐⭐⭐ 3 — Regular
⭐⭐⭐⭐ 4 — Bom
⭐⭐⭐⭐⭐ 5 — Excelente

E se quiser comentar algo — elogio ou crítica — pode falar à vontade! Adoramos feedback. 💬

Obrigado pela confiança! 💙`,
      },
      {
        label: "Pedido de depoimento",
        badge: null,
        text: `Oi! Tudo bem? 😊

Você tá usando o *FluxoEasy* faz um tempo e fico feliz de saber que tá ajudando!

Teria como me deixar um depoimento rápido sobre a sua experiência? Pode ser um textinho simples mesmo — isso nos ajuda muito a crescer e chegar em mais pessoas!

Obrigado! 🙏💙`,
      },
    ],
  },
  {
    cat: "Dicas rápidas",
    icon: "💡",
    items: [
      {
        label: "Dica — como gerar PDF do orçamento",
        badge: null,
        text: `Dica rápida! 💡

Para gerar o *PDF do orçamento* no FluxoEasy:

1️⃣ Abra o orçamento
2️⃣ Clique no botão "Gerar PDF" ou "Imprimir"
3️⃣ Salve ou compartilhe direto com o cliente!

O PDF já sai com a logo da sua empresa e os dados organizados. 🔥

Alguma dúvida? Me chama! 😊`,
      },
      {
        label: "Dica — como adicionar usuário",
        badge: null,
        text: `Dica rápida! 💡

Para adicionar um *novo usuário* no FluxoEasy:

1️⃣ Vá em Configurações > Usuários
2️⃣ Clique em "Novo usuário"
3️⃣ Preencha nome, login e senha
4️⃣ Defina o nível de acesso

Pronto! Seu colaborador já pode entrar com o login dele. 😊

Dúvida? Me chama! 💙`,
      },
      {
        label: "Dica — dados salvos em nuvem",
        badge: null,
        text: `Dica importante! 💡

Seu sistema *FluxoEasy* fica salvo em nuvem — você não precisa fazer backup manual!

Mas se quiser exportar seus dados (lista de clientes, produtos, vendas), é só ir em *Relatórios* e exportar em Excel ou PDF.

Qualquer dúvida me chama! 😊💙`,
      },
    ],
  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

const ALL = "Todas";

// ─── Main Page ────────────────────────────────────────────────────────────────

const MensagensPage = () => {
  const [busca, setBusca] = useState("");
  const [catAtiva, setCatAtiva] = useState(ALL);
  const [expandido, setExpandido] = useState({});
  const [copiado, setCopiado] = useState({});

  const cats = [ALL, ...MSGS.map((g) => g.cat)];

  const grupos = useMemo(() => {
    const q = busca.toLowerCase();
    return MSGS.map((group) => ({
      ...group,
      items: group.items.filter(
        (m) =>
          (catAtiva === ALL || catAtiva === group.cat) &&
          (!q ||
            m.label.toLowerCase().includes(q) ||
            m.text.toLowerCase().includes(q))
      ),
    })).filter((g) => g.items.length > 0);
  }, [busca, catAtiva]);

  const toggleExpand = (key) =>
    setExpandido((p) => ({ ...p, [key]: !p[key] }));

  const copiar = async (key, text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopiado((p) => ({ ...p, [key]: true }));
    setTimeout(() => setCopiado((p) => ({ ...p, [key]: false })), 2000);
  };

  return (
    <main className={styles.page} aria-label="Mensagens prontas">
      <div className={styles.pageHeader}>
        <div>
          <h1 className={styles.pageTitle}>Mensagens prontas</h1>
          <p className={styles.pageSubtitle}>
            Copie e envie direto pelo WhatsApp para seus clientes
          </p>
        </div>
      </div>

      {/* Busca */}
      <div className={styles.searchWrap}>
        <input
          type="search"
          className={styles.searchInput}
          placeholder="Buscar mensagem..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          aria-label="Buscar mensagem"
        />
      </div>

      {/* Filtros por categoria */}
      <div className={styles.cats} role="tablist" aria-label="Categorias">
        {cats.map((c) => (
          <button
            key={c}
            type="button"
            role="tab"
            aria-selected={catAtiva === c}
            className={`${styles.catBtn} ${catAtiva === c ? styles.catBtnActive : ""}`}
            onClick={() => setCatAtiva(c)}
          >
            {c}
          </button>
        ))}
      </div>

      {/* Grupos de mensagens */}
      {grupos.length === 0 ? (
        <div className={styles.empty}>
          Nenhuma mensagem encontrada para "{busca}"
        </div>
      ) : (
        grupos.map((group) => (
          <section key={group.cat} className={styles.section}>
            <h2 className={styles.sectionTitle}>
              <span className={styles.sectionIcon}>{group.icon}</span>
              {group.cat}
            </h2>
            <div className={styles.cards}>
              {group.items.map((msg, i) => {
                const key = `${group.cat}_${i}`;
                const isExp = expandido[key];
                const isCopied = copiado[key];

                return (
                  <div key={key} className={styles.card}>
                    <div className={styles.cardHead}>
                      <span className={styles.cardLabel}>
                        {msg.label}
                        {msg.badge === "promo" && (
                          <span className={styles.badgePromo}>promoção</span>
                        )}
                      </span>
                    </div>

                    <pre
                      className={`${styles.preview} ${isExp ? styles.previewExpanded : ""}`}
                      onClick={() => toggleExpand(key)}
                      title="Clique para expandir"
                    >
                      {msg.text.replace(/\*/g, "")}
                    </pre>

                    <div className={styles.cardActions}>
                      <button
                        type="button"
                        className={`${styles.btn} ${isCopied ? styles.btnCopied : ""}`}
                        onClick={() => copiar(key, msg.text)}
                        aria-label={`Copiar mensagem: ${msg.label}`}
                      >
                        {isCopied ? "✓ Copiado!" : "Copiar"}
                      </button>
                      <button
                        type="button"
                        className={styles.btn}
                        onClick={() => toggleExpand(key)}
                      >
                        {isExp ? "Ver menos" : "Ver tudo"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        ))
      )}
    </main>
  );
};

export default MensagensPage;